import React from "react";
import styles from '../style/components/VideoLoader.module.css'

const VideoLoader = () => {
    return (
    <div className={styles.loaderOverlay}>
      <div className={styles.loader}></div>
      <p className={styles.loaderText}>Загрузка видео...</p>
    </div>
    )
}

export default VideoLoader